export const fetchMedias = resp => ({
  type: "FETCH_MEDIAS",
  payload: resp
});

export const resetMediasByType = (type = "ALL") => ({
  type: `RESET_MEDIAS_${type.toUpperCase()}`
});

export const fetchMediasByType = (type = "ALL") => resp => ({
  type: `FETCH_MEDIAS_${type.toUpperCase()}`,
  payload: resp,
  append: true
});

export const fetchInfiniteMediasByType = (type = "ALL") => resp => ({
  type: `FETCH_INFINITE_MEDIAS_${type.toUpperCase()}`,
  payload: resp
});

export const saveMedia = resp => ({
  type: "SAVE_MEDIA",
  payload: resp
});

export const addUploadingMedias = items => ({
  type: "ADD_UPLOADING_MEDIAS",
  items
});

export const setUploadingMedias = items => ({
  type: "SET_UPLOADING_MEDIAS",
  items
});



// WEBPACK FOOTER //
// ./src/actions/actions/media.js